"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _solarReact = require("@solar/solar-react");

var _ChevronRight = _interopRequireDefault(require("@material-ui/icons/ChevronRight"));

var _FormEditor = require("./FormEditor");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ProductTypeListItem = function ProductTypeListItem(_ref) {
  var productKey = _ref.productKey,
      title = _ref.title,
      _onClick = _ref.onClick,
      selected = _ref.selected;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.ListItem, {
    button: true,
    onClick: function onClick() {
      return _onClick(productKey);
    },
    selected: selected
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemText, {
    primary: productKey,
    secondary: title,
    lines: "two"
  }), /*#__PURE__*/_react["default"].createElement(_solarReact.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_ChevronRight["default"], null)));
};

var ProductTypeSelector = function ProductTypeSelector(_ref2) {
  var types = _ref2.types,
      activeType = _ref2.activeType,
      onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_core.List, null, /*#__PURE__*/_react["default"].createElement(ProductTypeListItem, {
    productKey: "general",
    title: "algemeen",
    onClick: onChange,
    selected: activeType === 'general'
  }), types.map(function (_ref3) {
    var key = _ref3.key,
        title = _ref3.title;
    return /*#__PURE__*/_react["default"].createElement(ProductTypeListItem, {
      productKey: key,
      title: title,
      onClick: onChange,
      selected: activeType === key
    });
  }));
};

var useSplitViewStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {},
    sidebar: {
      borderRight: "solid 1px ".concat(theme.palette.divider),
      backgroundColor: theme.palette.background.paper
    },
    sidebarFull: {}
  };
});

var ProductDataEditor = function ProductDataEditor(_ref4) {
  var title = _ref4.title,
      types = _ref4.types,
      formJSON = _ref4.formJSON,
      formUIJSON = _ref4.formUIJSON,
      formData = _ref4.formData,
      loading = _ref4.loading,
      openProduct = _ref4.openProduct,
      onChangeFormJSON = _ref4.onChangeFormJSON,
      onChangeFormUIJSON = _ref4.onChangeFormUIJSON,
      onChangeFormData = _ref4.onChangeFormData,
      onSave = _ref4.onSave,
      onRestore = _ref4.onRestore,
      isDirty = _ref4.isDirty,
      labels = _ref4.labels;

  var _useState = (0, _react.useState)('general'),
      _useState2 = _slicedToArray(_useState, 2),
      selectedType = _useState2[0],
      setSelectedType = _useState2[1];

  var splitViewClasses = useSplitViewStyles();

  var s = function s(cb) {
    return function (v) {
      return cb(v, selectedType);
    };
  };

  var hasTypes = types.length > 0;
  return /*#__PURE__*/_react["default"].createElement(_solarReact.Flex, {
    fullColumn: true
  }, /*#__PURE__*/_react["default"].createElement(_solarReact.ResponsiveAppBar, {
    title: title
  }), loading ? /*#__PURE__*/_react["default"].createElement(_core.LinearProgress, {
    color: "primary"
  }) : '', hasTypes && /*#__PURE__*/_react["default"].createElement(_solarReact.SplitView, {
    classes: splitViewClasses,
    sideContent: /*#__PURE__*/_react["default"].createElement(_FormEditor.FormEditor, {
      formJSON: formJSON,
      formUIJSON: formUIJSON,
      formData: formData,
      onChangeFormJSON: s(onChangeFormJSON),
      onChangeFormUIJSON: s(onChangeFormUIJSON),
      onChangeFormData: s(onChangeFormData),
      onSave: onSave,
      onRestore: onRestore,
      isDirty: isDirty,
      selectedType: selectedType
    })
  }, /*#__PURE__*/_react["default"].createElement(ProductTypeSelector, {
    onChange: setSelectedType,
    activeType: selectedType,
    types: types
  })), !hasTypes && /*#__PURE__*/_react["default"].createElement(_FormEditor.FormEditor, {
    formJSON: formJSON,
    formUIJSON: formUIJSON,
    formData: formData,
    onChangeFormJSON: s(onChangeFormJSON),
    onChangeFormUIJSON: s(onChangeFormUIJSON),
    onChangeFormData: s(onChangeFormData),
    onSave: onSave,
    onRestore: onRestore,
    isDirty: isDirty,
    selectedType: selectedType
  }));
};

var _default = ProductDataEditor;
exports["default"] = _default;